export default __webpack_public_path__ + "static/media/home-upload-file.e2c30a15.svg";